// useNodeFieldChange.js

import { useCallback } from 'react';

import { coerceFromInput } from 'utilities/NodeFieldCoercion';
import { buildNodeFieldPatch } from 'utilities/NodeFieldData';
import { augmentPurchaseOrderItemTotalPatch } from 'nodetypes/purchaseorder/view/purchaseOrderItemsModel';

export default function useNodeFieldChange({ node, nodeTypeKey, onChange }) {
  return useCallback((field, raw) => {
    if (!field) return;

    // primitives -> node.data_{source}
    const parsed =
      field.type === 'boolean'
        ? raw?.target
          ? raw.target.checked
          : !!raw
        : raw?.target
          ? raw.target.value
          : raw;

    const value = coerceFromInput(parsed, field.type, field);

    const basePatch = buildNodeFieldPatch(node, field, nodeTypeKey, value);
    if (!basePatch) return;

    const patch = augmentPurchaseOrderItemTotalPatch({
      node,
      nodeTypeKey,
      field,
      value,
      patch: basePatch,
    }) || basePatch;

    onChange(node.key, patch);
  }, [node, nodeTypeKey, onChange]);
}
